import * as types from "./types";

const INITIAL_STATE = {
  // Création
  creating_consultation: false,
  current_consultation: null,

  // Suppression
  deleting_consultation: false,

  // Liste par patient (tableau plat)
  getting_consultations: false,
  consultations: [],

  // Erreurs (compatibilité existante : tableau d'objets {message})
  errors: []
};

function ConsultationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // ---------- CREATE ----------
    case types.CREATE_CONSULTATION_REQUEST:
      return { ...state, creating_consultation: true, errors: [] };
    case types.CREATE_CONSULTATION_SUCCESS:
      return {
        ...state,
        creating_consultation: false,
        current_consultation: action.payload || state.current_consultation,
        errors: []
      };
    case types.CREATE_CONSULTATION_FAILURE:
      return {
        ...state,
        creating_consultation: false,
        errors: action.payload || []
      };

    // ---------- DELETE ----------
    case types.DELETE_CONSULTATION_REQUEST:
      return { ...state, deleting_consultation: true };
    case types.DELETE_CONSULTATION_SUCCESS: {
      const removedId = action.payload?.id;
      return {
        ...state,
        deleting_consultation: false,
        consultations:
          removedId != null
            ? state.consultations.filter((c) => c?.id !== removedId)
            : state.consultations
      };
    }
    case types.DELETE_CONSULTATION_FAILURE:
      return { ...state, deleting_consultation: false, errors: action.payload || [] };

    // ---------- GET BY ID ----------
    case types.GET_CONSULTATION_BY_ID_REQUEST:
      return { ...state };
    case types.GET_CONSULTATION_BY_ID_SUCCESS:
      return { ...state, current_consultation: action.payload };
    case types.GET_CONSULTATION_BY_ID_FAILURE:
      return { ...state, errors: action.payload || [] };

    // ---------- GET BY PATIENT ----------
    case types.GET_CONSULTATIONS_BY_PATIENT_REQUEST:
      return { ...state, getting_consultations: true };
    case types.GET_CONSULTATIONS_BY_PATIENT_SUCCESS:
      return {
        ...state,
        getting_consultations: false,
        consultations: Array.isArray(action.payload) ? action.payload : []
      };
    case types.GET_CONSULTATIONS_BY_PATIENT_FAILURE:
      return { ...state, getting_consultations: false, consultations: [] };

    default:
      return state;
  }
}

export default ConsultationsReducer;
